export default "__VITE_ASSET__4GKgGUZn__"